import { CopyrightNotice } from './CopyrightNotice';
import { LegalLinks } from './LegalLinks';
import { SocialLinks } from './SocialLinks';
interface FooterBottomProps {
  hideSocials?: boolean;
}
const FooterBottom = ({
  hideSocials = false
}: FooterBottomProps) => <div className="flex flex-col md:min-h-[60px] md:flex-row md:justify-between md:bg-gray-100 md:px-container md:py-4 xl:items-center xl:py-2.5 md:dark:bg-gray-800" data-sentry-component="FooterBottom" data-sentry-source-file="FooterBottom.tsx">
    <div className="flex flex-col gap-3 md:gap-0 xl:grow xl:basis-[70%] xl:flex-row xl:items-center xl:justify-between">
      <div className="xl:grow xl:basis-[42.86%]">
        <LegalLinks data-sentry-element="LegalLinks" data-sentry-source-file="FooterBottom.tsx" />
      </div>
      <div className="md:text-center xl:mx-auto xl:grow xl:basis-[57.14%]">
        <CopyrightNotice data-sentry-element="CopyrightNotice" data-sentry-source-file="FooterBottom.tsx" />
      </div>
    </div>
    <div className="-order-1 md:order-none md:flex md:items-center md:justify-end xl:grow xl:basis-[30%]">
      {!hideSocials && <SocialLinks />}
    </div>
  </div>;
export default FooterBottom;